import React, { ChangeEventHandler, useCallback } from 'react';

import { useThreeDStockContentScale } from '../../../../../hooks/useThreeDStockContentScale';
import { useThreeDStockContentView } from '../../../../../hooks/useThreeDStockContentView';

import { Icon } from '../../../../../../../helpers/Icon';

import { IconsEnum } from '../../../../../../../assets/icons/types';
import { StockTabs } from '../../../../../stockConstants';

interface ThreeDStockContentImageScaleButtonProps {
  tab: StockTabs;
}

function ThreeDStockContentImageScaleButton({
  tab
}: ThreeDStockContentImageScaleButtonProps) {
  const { isGridView, isGridViewFetched } = useThreeDStockContentView({ tab });
  const { scale, setScale } = useThreeDStockContentScale({ tab });

  const handleChangeScale = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      setScale(Number(e.target.value));
    },
    [setScale]
  );

  if (!isGridView || !isGridViewFetched) {
    return null;
  }

  return (
    <div className="hidden md:block p-2.5 border border-gray-300 dark:border-gray-700 shadow-sm bg-white dark:bg-gray-800 rounded-md">
      <div className="flex gap-x-1 items-center">
        <Icon icon={IconsEnum.VIEW_GRID_SM} className="h-5 w-5" />
        <input
          data-ga="products-image-scale-range-input"
          id="attachment-size-range"
          type="range"
          min="168"
          max="480"
          step="1"
          value={scale}
          className="h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-600 w-56"
          onChange={handleChangeScale}
        />
        <Icon icon={IconsEnum.VIEW_GRID} className="h-5 w-5" />
      </div>
    </div>
  );
}

export default ThreeDStockContentImageScaleButton;
